<template>
    <div :class="classes">
        <label>{{text}}</label>
        
        <input type="text" placeholder="0" v-model="value" @input="onInput" v-if="!readonly">
        
        <input type="text" :value="sum" @input="onInput" v-if="readonly" :readonly="readonly">
    </div>
</template>

<script>
    export default {
        data() {
            return {
                value: ""
            };
        },

        props: {
            text: {
                type: String,
                required: false
            },

            sum: {
                type: String | Number,
                required: false
            },

            readonly: {
                type: Boolean,
                required: true
            },

            isCurrency: {
                type: Boolean,
                required: false,
                default: false
            },

            sanitizeFunction: {
                type: Function,
                required: false
            },

            initialValue: {
                type: Number | String,
                required: false,
                default: undefined
            }
        },

        methods: {
            onInput(event) {
                let sanitizedVal = this.value;
                if (typeof this.sanitizeFunction === "function") {
                    sanitizedVal = this.sanitizeFunction(event.target.value);
                    this.value = sanitizedVal;
                }

                this.$emit("changed", sanitizedVal);
            }
        },

        computed: {
            classes() {
                return {
                    "c-field": true,
                    "c-field--currency": this.isCurrency
                };
            }
        },

        created() {
            if (typeof this.initialValue !== "undefined") {
                this.value = this.initialValue;
            }
        }
    };
</script>

<style lang="scss">
    .c-field {
        display: flex;
        flex-flow: column;
        font-family: "Roboto", sans-serif;
        font-size: 0.75rem;
        color: #979797;
        font-weight: 500;
        margin: 0 1.25rem 0 0.3125rem;
        border-bottom: 1px solid #979797;
        width: 55%;
        position: relative;
        line-height: 0.875rem;

        label {
            padding-bottom: 0.4375rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        input {
            font-size: 1.125rem;
            line-height: 1.5rem;
            padding: 0.75rem 0 0.375rem 0.625rem;
            border: none;
            position: relative;

            &:focus {
                outline: none;
            }
        }

        &--currency {
            label {
                &::before {
                    content: "$";
                    position: absolute;
                    z-index: 5;
                    left: 0;
                    top: 2.35rem;
                    font-size: 1.125rem;
                    color: #000;

                    @media screen and (max-width: 1024px) {
                        top: 3rem;
                    }
                }
            }

            input {
                padding-left: 0.9375rem;
            }
        }

        @media screen and (max-width: 1024px) {
            width: 73%;
            padding-top: 0.625rem;
        }
    }
</style>

